module.exports = __webpack_public_path__ + "media/images/cover_station_bookings-0d2ba2765fe779649b6b611929dd1c1b.jpg";